let BASE_API_URI = process.env.REACT_APP_BASE_API_URI;

const BASE_ANALYTICS_API_URI = process.env.REACT_APP_BASE_ANALYTICS_API_URI;
const BASE_AI_URI = process.env.REACT_APP_BASE_AI_URI;
const BASE_ML_URI = process.env.REACT_APP_BASE_ML_URI;
const BASE_ANALYTICS_URI = process.env.REACT_APP_BASE_ANALYTICS_URI;
const BASE_PHONE_REGISTRATION_URI =
  process.env.REACT_APP_BASE_PHONE_REGISTRATION_URI;
const BASE_WEBAPP_URI = process.env.REACT_APP_BASE_WEBAPP_URI;
const DEPLOYMENT_VERSION = process.env.REACT_APP_DEPLOYMENT_VERSION;
const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
const LAUNCH_DARKLY_CLIENTSIDE_ID =
  process.env.REACT_APP_LAUNCH_DARKLY_CLIENTSIDE_ID;
const UNIFIED_LOGIN_URL = process.env.REACT_APP_UNIFIED_LOGIN_URL;
const UNIFIED_ENVIRONMENT = process.env.REACT_APP_UNIFIED_ENVIRONMENT;

// Separate flag to avoid errors resulting from different dev environment configurations
// between knock-vagrant and knock-docker

const DEV_ENVIRONMENT_TYPE = process.env.REACT_APP_DEV_ENVIRONMENT_TYPE;

if (
  process.env.NODE_ENV === 'development' &&
  DEV_ENVIRONMENT_TYPE === 'docker'
) {
  // env variables that need to be different from the defaults above for docker dev environment
  BASE_API_URI = 'http://localhost:5000/v1/';
}

export {
  BASE_API_URI,
  BASE_AI_URI,
  BASE_ML_URI,
  BASE_ANALYTICS_URI,
  BASE_ANALYTICS_API_URI,
  BASE_PHONE_REGISTRATION_URI,
  BASE_WEBAPP_URI,
  DEPLOYMENT_VERSION,
  ENVIRONMENT,
  LAUNCH_DARKLY_CLIENTSIDE_ID,
  UNIFIED_LOGIN_URL,
  UNIFIED_ENVIRONMENT,
};
